(function () {
  'use strict';


  /* =========================================================
     DETECT CURRENT MARKET
  ========================================================= */

  function detectMarketCode() {

    var host = String(
      window.location.hostname || ''
    )
      .toLowerCase()
      .replace(/^www\./, '');


    var path = String(
      window.location.pathname || '/'
    )
      .toLowerCase()
      .replace(/\/+$/, '');


    if (!path) {
      path = '/';
    }


    /* =========================================================
       SUBDOMAIN DETECTION
    ========================================================= */

    var domainMarkets = {
      'uk.medetone.com': 'UK',
      'us.medetone.com': 'US',

      'fr.medetone.com': 'FR',
      'de.medetone.com': 'DE',
      'at.medetone.com': 'AT',
      'it.medetone.com': 'IT',
      'es.medetone.com': 'ES',
      'nl.medetone.com': 'NL',
      'be.medetone.com': 'BE',
      'ch.medetone.com': 'CH'
    };


    if (domainMarkets[host]) {
      return domainMarkets[host];
    }


    /* =========================================================
       MAIN DOMAIN FALLBACK

       This keeps old URLs working too:

       medetone.com/fr
       medetone.com/de
       medetone.com/it
       etc.
    ========================================================= */

    if (host === 'medetone.com') {


      /* FRANCE */

      if (
        path === '/fr' ||
        path.indexOf('/fr/') === 0
      ) {
        return 'FR';
      }


      /* GERMANY */

      if (
        path === '/de' ||
        path.indexOf('/de/') === 0
      ) {
        return 'DE';
      }


      /* AUSTRIA */

      if (
        path === '/at' ||
        path.indexOf('/at/') === 0
      ) {
        return 'AT';
      }


      /* ITALY */

      if (
        path === '/it' ||
        path.indexOf('/it/') === 0 ||
        path === '/en-it' ||
        path.indexOf('/en-it/') === 0
      ) {
        return 'IT';
      }


      /* SPAIN */

      if (
        path === '/es' ||
        path.indexOf('/es/') === 0
      ) {
        return 'ES';
      }


      /* NETHERLANDS */

      if (
        path === '/nl' ||
        path.indexOf('/nl/') === 0
      ) {
        return 'NL';
      }


      /* BELGIUM */

      if (
        path === '/be' ||
        path.indexOf('/be/') === 0
      ) {
        return 'BE';
      }


      /* SWITZERLAND */

      if (
        path === '/ch' ||
        path.indexOf('/ch/') === 0
      ) {
        return 'CH';
      }


      return 'ROW';
    }


    /* =========================================================
       SHOPIFY PREVIEW

       Shopify preview domains do not tell us which public
       Medetone subdomain is being used.

       Use ROW as safe fallback.
    ========================================================= */

    if (
      host.endsWith('.myshopify.com')
    ) {
      return 'ROW';
    }


    /* =========================================================
       UNKNOWN DOMAIN
    ========================================================= */

    return 'ROW';
  }



  /* =========================================================
     INITIALISE ONE SELECTOR
  ========================================================= */

  function initialiseSelector(
    selector,
    index
  ) {

    if (!selector) {
      return;
    }


    if (
      selector.getAttribute(
        'data-med-market-initialised'
      ) === 'true'
    ) {
      return;
    }



    /* =========================================================
       GET ELEMENTS
    ========================================================= */

    var button =
      selector.querySelector(
        '[data-med-market-button]'
      );


    var dropdown =
      selector.querySelector(
        '[data-med-market-dropdown]'
      );


    var list =
      dropdown
        ? dropdown.querySelector(
            '[data-med-market-list]'
          )
        : null;


    var currentFlag =
      selector.querySelector(
        '[data-med-current-flag]'
      );


    var currentCode =
      selector.querySelector(
        '[data-med-current-code]'
      );


    var items =
      dropdown
        ? Array.prototype.slice.call(
            dropdown.querySelectorAll(
              '[data-med-market-item]'
            )
          )
        : [];


    if (
      !button ||
      !dropdown ||
      !list ||
      !items.length
    ) {

      console.warn(
        'Medetone market selector could not initialise.',
        {
          button: button,
          dropdown: dropdown,
          list: list,
          items: items.length
        }
      );

      return;
    }


    selector.setAttribute(
      'data-med-market-initialised',
      'true'
    );



    /* =========================================================
       UNIQUE DROPDOWN ID
    ========================================================= */

    var dropdownId =
      'med-market-dropdown-' +
      Date.now() +
      '-' +
      index +
      '-' +
      Math.random()
        .toString(36)
        .substring(2, 7);


    dropdown.id =
      dropdownId;


    button.setAttribute(
      'aria-controls',
      dropdownId
    );



    /* =========================================================
       DETECT CURRENT MARKET
    ========================================================= */

    var detectedCode =
      detectMarketCode();


    var selectedItem =
      null;


    for (
      var i = 0;
      i < items.length;
      i++
    ) {

      if (
        items[i].getAttribute(
          'data-market-code'
        ) === detectedCode
      ) {

        selectedItem =
          items[i];

        break;
      }
    }



    /* =========================================================
       FALLBACK TO ROW
    ========================================================= */

    if (!selectedItem) {

      for (
        var rowIndex = 0;
        rowIndex < items.length;
        rowIndex++
      ) {

        if (
          items[rowIndex].getAttribute(
            'data-market-code'
          ) === 'ROW'
        ) {

          selectedItem =
            items[rowIndex];

          break;
        }
      }
    }



    /* =========================================================
       FINAL FALLBACK
    ========================================================= */

    if (!selectedItem) {
      selectedItem =
        items[0];
    }



    /* =========================================================
       SET CURRENT MARKET
    ========================================================= */

    function setCurrentMarket(item) {

      if (!item) {
        return;
      }


      for (
        var itemIndex = 0;
        itemIndex < items.length;
        itemIndex++
      ) {

        items[
          itemIndex
        ].removeAttribute(
          'aria-current'
        );
      }


      item.setAttribute(
        'aria-current',
        'page'
      );


      var sourceFlag =
        item.querySelector(
          '.med-market-dropdown__flag'
        );


      if (
        sourceFlag &&
        currentFlag
      ) {

        currentFlag.innerHTML =
          sourceFlag.innerHTML;
      }


      var code =
        item.getAttribute(
          'data-market-code'
        );


      if (
        currentCode &&
        code
      ) {

        currentCode.textContent =
          code;
      }


      var marketNameElement =
        item.querySelector(
          '.med-market-dropdown__name'
        );


      var marketName =
        marketNameElement
          ? marketNameElement.textContent.trim()
          : 'market';


      button.setAttribute(
        'aria-label',
        'Current market: ' +
        marketName +
        '. Choose another market'
      );
    }


    setCurrentMarket(
      selectedItem
    );



    /* =========================================================
       HIDE DROPDOWN BEFORE MOVING
    ========================================================= */

    dropdown.hidden =
      true;


    dropdown.classList.remove(
      'is-open'
    );



    /* =========================================================
       MOVE DROPDOWN TO BODY

       Prevents Shopify footer/header/drawer containers
       from clipping the dropdown.
    ========================================================= */

    document.body.appendChild(
      dropdown
    );



    /* =========================================================
       POSITION DROPDOWN
    ========================================================= */

    function positionDropdown() {

      if (
        !selector.classList.contains(
          'is-open'
        )
      ) {
        return;
      }


      var rect =
        button.getBoundingClientRect();


      var viewportWidth =
        window.innerWidth ||
        document.documentElement.clientWidth;


      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;


      var sideGap =
        20;


      if (
        viewportWidth <= 749
      ) {
        sideGap =
          14;
      }


      if (
        viewportWidth <= 480
      ) {
        sideGap =
          12;
      }


      if (
        viewportWidth <= 360
      ) {
        sideGap =
          8;
      }


      var buttonGap =
        12;


      var maxWidth =
        viewportWidth <= 749
          ? 420
          : 440;


      var dropdownWidth =
        Math.min(
          maxWidth,
          viewportWidth -
          sideGap * 2
        );


      var left =
        rect.right -
        dropdownWidth;


      if (
        left < sideGap
      ) {

        left =
          sideGap;
      }


      if (
        left +
        dropdownWidth >
        viewportWidth -
        sideGap
      ) {

        left =
          viewportWidth -
          dropdownWidth -
          sideGap;
      }


      var spaceAbove =
        rect.top -
        buttonGap -
        sideGap;


      var spaceBelow =
        viewportHeight -
        rect.bottom -
        buttonGap -
        sideGap;


      var openAbove =
        spaceAbove >=
        spaceBelow;


      var availableSpace =
        openAbove
          ? spaceAbove
          : spaceBelow;


      var maxPanelHeight =
        viewportWidth <= 480
          ? 450
          : 510;


      var panelHeight =
        Math.min(
          maxPanelHeight,
          Math.max(
            170,
            availableSpace
          )
        );


      dropdown.style.width =
        dropdownWidth + 'px';


      dropdown.style.left =
        left + 'px';


      dropdown.style.maxHeight =
        panelHeight + 'px';


      list.style.maxHeight =
        Math.max(
          130,
          panelHeight - 20
        ) + 'px';



      /* =========================================================
         OPEN ABOVE
      ========================================================= */

      if (openAbove) {

        dropdown.setAttribute(
          'data-placement',
          'above'
        );


        dropdown.style.top =
          'auto';


        dropdown.style.bottom =
          (
            viewportHeight -
            rect.top +
            buttonGap
          ) + 'px';
      }



      /* =========================================================
         OPEN BELOW
      ========================================================= */

      else {

        dropdown.setAttribute(
          'data-placement',
          'below'
        );


        dropdown.style.bottom =
          'auto';


        dropdown.style.top =
          (
            rect.bottom +
            buttonGap
          ) + 'px';
      }
    }



    /* =========================================================
       OPEN DROPDOWN
    ========================================================= */

    function openDropdown() {

      if (
        !selector.isConnected
      ) {
        return;
      }


      dropdown.hidden =
        false;


      selector.classList.add(
        'is-open'
      );


      button.setAttribute(
        'aria-expanded',
        'true'
      );


      positionDropdown();


      window.requestAnimationFrame(
        function () {

          dropdown.classList.add(
            'is-open'
          );


          /*
            Keep current country visible
            when dropdown opens.
          */

          if (selectedItem) {

            var itemTop =
              selectedItem.offsetTop;


            list.scrollTop =
              Math.max(
                0,
                itemTop - 20
              );
          }
        }
      );
    }



    /* =========================================================
       CLOSE DROPDOWN
    ========================================================= */

    function closeDropdown(
      returnFocus
    ) {

      selector.classList.remove(
        'is-open'
      );


      dropdown.classList.remove(
        'is-open'
      );


      button.setAttribute(
        'aria-expanded',
        'false'
      );


      window.setTimeout(
        function () {

          if (
            !selector.classList.contains(
              'is-open'
            )
          ) {

            dropdown.hidden =
              true;
          }

        },
        170
      );


      if (
        returnFocus &&
        selector.isConnected
      ) {

        button.focus();
      }
    }



    /* =========================================================
       BUTTON CLICK
    ========================================================= */

    button.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();


        if (
          selector.classList.contains(
            'is-open'
          )
        ) {

          closeDropdown(
            false
          );
        }

        else {

          openDropdown();
        }
      }
    );



    /* =========================================================
       COUNTRY / MARKET LINKS

       Native anchor navigation is intentionally preserved.
       This is required for navigating between subdomains.
    ========================================================= */

    for (
      var linkIndex = 0;
      linkIndex < items.length;
      linkIndex++
    ) {

      items[
        linkIndex
      ].addEventListener(
        'click',
        function () {

          closeDropdown(
            false
          );
        }
      );
    }



    /* =========================================================
       CLICK OUTSIDE
    ========================================================= */

    document.addEventListener(
      'click',
      function (event) {

        if (
          !selector.contains(
            event.target
          ) &&
          !dropdown.contains(
            event.target
          )
        ) {

          closeDropdown(
            false
          );
        }
      }
    );



    /* =========================================================
       ESCAPE
    ========================================================= */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'Escape'
        ) {

          if (
            selector.classList.contains(
              'is-open'
            )
          ) {

            closeDropdown(
              true
            );
          }
        }
      }
    );



    /* =========================================================
       KEYBOARD NAVIGATION
    ========================================================= */

    dropdown.addEventListener(
      'keydown',
      function (event) {

        var active =
          document.activeElement;


        var currentIndex =
          items.indexOf(
            active
          );


        /* ARROW DOWN */

        if (
          event.key ===
          'ArrowDown'
        ) {

          event.preventDefault();


          var next =
            (
              currentIndex +
              1 +
              items.length
            ) %
            items.length;


          items[
            next
          ].focus();
        }


        /* ARROW UP */

        if (
          event.key ===
          'ArrowUp'
        ) {

          event.preventDefault();


          var previous =
            (
              currentIndex -
              1 +
              items.length
            ) %
            items.length;


          items[
            previous
          ].focus();
        }


        /* HOME */

        if (
          event.key ===
          'Home'
        ) {

          event.preventDefault();

          items[
            0
          ].focus();
        }


        /* END */

        if (
          event.key ===
          'End'
        ) {

          event.preventDefault();

          items[
            items.length - 1
          ].focus();
        }
      }
    );



    /* =========================================================
       WINDOW RESIZE
    ========================================================= */

    window.addEventListener(
      'resize',
      function () {

        if (
          selector.classList.contains(
            'is-open'
          )
        ) {

          positionDropdown();
        }
      }
    );



    /* =========================================================
       WINDOW / CONTAINER SCROLL
    ========================================================= */

    var scrollTimer =
      null;


    window.addEventListener(
      'scroll',
      function () {

        if (
          !selector.classList.contains(
            'is-open'
          )
        ) {

          return;
        }


        if (scrollTimer) {

          window.cancelAnimationFrame(
            scrollTimer
          );
        }


        scrollTimer =
          window.requestAnimationFrame(
            function () {

              positionDropdown();
            }
          );

      },
      true
    );
  }



  /* =========================================================
     INITIALISE ALL MARKET SELECTORS

     Supports multiple selectors:
     - Footer
     - Phone drawer
     - Desktop drawer
  ========================================================= */

  function initialiseAll(
    root
  ) {

    root =
      root ||
      document;


    var selectors;


    if (
      root.matches &&
      root.matches(
        '[data-med-market-selector]'
      )
    ) {

      selectors =
        [root];
    }

    else {

      selectors =
        root.querySelectorAll(
          '[data-med-market-selector]'
        );
    }


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {

      initialiseSelector(
        selectors[i],
        i
      );
    }
  }



  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initialiseAll(
          document
        );
      }
    );
  }

  else {

    initialiseAll(
      document
    );
  }



  /* =========================================================
     SHOPIFY THEME EDITOR

     Reinitialise selector when Shopify reloads
     a section in the theme editor.
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initialiseAll(
        event.target
      );
    }
  );



  /* =========================================================
     CLEAN ORPHAN DROPDOWNS

     Dropdowns are moved into document.body.

     If Shopify removes the original section/button,
     remove its detached dropdown too.
  ========================================================= */

  var cleanupObserver =
    new MutationObserver(
      function () {

        var portals =
          document.querySelectorAll(
            'body > .med-market-dropdown'
          );


        for (
          var i = 0;
          i < portals.length;
          i++
        ) {

          var portal =
            portals[i];


          var controlledBy =
            portal.id;


          if (!controlledBy) {
            continue;
          }


          var controllingButton =
            document.querySelector(
              '[aria-controls="' +
              controlledBy +
              '"]'
            );


          if (
            !controllingButton
          ) {

            portal.remove();
          }
        }
      }
    );


  cleanupObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();